var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Count: "+_vm._s(_vm.counter))]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.counter++}}},[_vm._v("+1")])])
}
var staticRenderFns = []

export { render, staticRenderFns }